import { makeStyles } from "@fluentui/react-components";
import { IntlShape } from "react-intl";

export const formatDateIntl24 = (dateTime: string, intl: IntlShape) => {
  const date = intl.formatDate(dateTime)
  const time = intl.formatTime(dateTime, { hour12: false })
  return `${date} ${time}`
};

export const useChartStyles = makeStyles({
  intensityStyles: {
    padding: "18px",
  }
})